// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZdTON","form":"styles_form__ZkWs7","img":"styles_img__scSTK"};